import { z } from 'zod';
import { Input } from '@morph-mapper/types';
import { jsonValueSchema } from './json';
import { fnDescriptorSchema, zodDescriptorSchema } from './special';

const configSelectionOptionSchema = z.object({
  label: z.string(),
  value: jsonValueSchema,
});

export type SerializedConfigSelectionOption = z.infer<
  typeof configSelectionOptionSchema
>;

export const serializedConfigConditionSchema = z.object({
  hasValue: jsonValueSchema.optional(),
});

export type SerializedConfigCondition = z.infer<
  typeof serializedConfigConditionSchema
>;

export const serializedSchemaConfigOptionSchema = z.object({
  title: z.string(),
  description: z.string(),
  type: zodDescriptorSchema,
  input: z.nativeEnum(Input),
  selectionDeclareVariable: z.boolean().optional(),
  selection: z.array(configSelectionOptionSchema).optional(),
  default: jsonValueSchema.optional(),
  placeholder: z.string().optional(),
  advanced: z.boolean().optional(),
  options: z.object({ required: z.boolean() }).partial().optional(),
  conditions: z.record(z.string(), serializedConfigConditionSchema).optional(),
});

export type SerializedSchemaConfigOption = z.infer<
  typeof serializedSchemaConfigOptionSchema
>;

export const serializedSchemaConfigSectionSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  hidden: z.boolean().optional(),
  advanced: z.boolean().optional(),
  childConfigurations: z.array(z.string()).optional(),
  options: z.record(z.string(), serializedSchemaConfigOptionSchema),
  conditions: z
    .record(z.string(), z.record(z.string(), serializedConfigConditionSchema))
    .optional(),
  mutate: fnDescriptorSchema,
});

export type SerializedSchemaConfigSection = z.infer<
  typeof serializedSchemaConfigSectionSchema
>;

export const serializedSchemaConfigSchema = z.record(
  z.string(),
  serializedSchemaConfigSectionSchema,
);

export type SerializedSchemaConfig = z.infer<typeof serializedSchemaConfigSchema>;
